<app-example-format
  [title]="componentInfo.title"
  urlTSDocs="https://docs.kadaster.nl/ggc/ggs-ggc-library/tsdocs/classes/ggc-layer-image_src_lib_layer-image_ggc-layer-image.component.GgcSearchLocationComponent.html"
  urlVoorbeelden=""
  urlChangelog=""
  [codeHtmlPath]="'code/examples/example-layer/example-layer-wmts/example-layer-wmts.component.html'"
  [codeTypescriptPath]="'code/examples/example-layer/example-layer-wmts/example-layer-wmts.component.ts'"
  [codeScssPath]="'code/examples/example-layer/example-layer-wmts/example-layer-wmts.component.scss'"
  urlCodeHtml="example-snapping/example-layer-wmts/example-layer-wmts.component.html"
  urlCodeTypescript="example-snapping/example-layer-wmts/example-layer-wmts.component.ts"
  urlCodeScss="example-snapping/example-layer-wmts/example-layer-wmts.component.scss"
>
  @if (componentInfo.tags && componentInfo.tags?.length > 0) {
    <div page-labels>
      @for (tag of componentInfo.tags; track tag) {
        <span class="badge bg-primary mx-1">{{ tag.toLocaleLowerCase() }}</span>
      }
    </div>
  }

  <div page-introduction>
    <p>
      {{ componentInfo.introduction }}
    </p>
    <p>
      In het voorbeeld hieronder is een WMTS-kaart met de kadastrale kaart als
      laag toegevoegd aan de kaart.
    </p>
  </div>

  <div page-functionality>
    <!-- DOCS:START functionality -->
    <div class="map-container">
      <ggc-map [minZoomlevel]="12">
        <ggc-layer-brt-achtergrondkaart></ggc-layer-brt-achtergrondkaart>
        <ggc-wmts-layer [options]="wmtsLayerOptions"></ggc-wmts-layer>
      </ggc-map>
    </div>
    <!-- DOCS:END functionality -->
  </div>
</app-example-format>
